



















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MyRecord extends Vue {
    private loading = false;

    private pagedData = [];
    private pageSize = 15;
    private pageIndex = 1;
    private total = 0;
    private multipleSelection: any[] = [];

    formatTime(row: any, column: any, cellValue: number) {
        return `${Math.floor(cellValue / 60)} 分${cellValue % 60} 秒`;
    }

    created() {
        this.reload();
    }


    reload() {
        this.$apis.getMyFormalRecords(this.pageIndex, this.pageSize)
            .then((res: any) => {
                this.total = res.total;
                this.pagedData = res.data;
            });
    }

    // 页面尺寸变化
    onSizeChange(val: any) {
        this.pageSize = val;
        this.pageIndex = 1;
        this.reload();
    }

    // 当前页变化
    onCurrentChange(val: any) {
        this.pageIndex = val;
        this.reload();
    }

    // 多选改变
    onSelectionChange(rows: any) {
        this.multipleSelection = rows;
    }
}
